// noinspection JSUnresolvedReference

import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

// noinspection t
manager.register('ajax-filter', (component, elements, attributes, properties) => {
	const {
		filter,
		search,
		loader,
		container
	} = elements;

	const {
		getDataUrl,
	} = properties;

	let xhr = null;

	// Construct URLSearchParams object instance from current URL querystring.
	const queryParams = new URLSearchParams(window.location.search);

	const update = () => {
		const value = $(filter).dropdown('get value');
		let searchValue = (search && search.value.length >= 3)
			? search.value
			: null;

		if (!getDataUrl) {
			return;
		}

		if (loader) {
			$(loader).stop().show();
		}

		if (container) {
			container.innerHTML = '';
		}

		if (xhr) {
			xhr.abort();
		}

		if (value) {
			queryParams.set('filter', value);
		} else {
			queryParams.delete('filter');
		}

		if (searchValue) {
			queryParams.set('search', searchValue);
		} else {
			queryParams.delete('search');
		}

		xhr = manager.get(`${getDataUrl}?${queryParams.toString()}`, (response) => {

			// Replace current querystring with the new one.

			history.replaceState(null, null, (value || searchValue) ? "?" + queryParams.toString() : '?');

			if (container) {
				container.innerHTML = response;
				$(container).stop().fadeIn();
			}

			manager.execute(container);

			if (loader) {
				$(loader).stop().hide();
			}
		});
	};

	$(filter).dropdown({
		clearable: true,
		onChange:  update
	});

	search?.addEventListener('input', () => {
		const searchValue = search.value;
		if (searchValue.length >= 3 || searchValue.length === 0) {
			update();
		}
	});

	update();


});